import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import BlockHeader from '../BlockHeader';
import { default as MyZoneService, MyZoneResponse } from '../../services/MyZone';

import Cell from './Cell';
import SmallCell from './SmallCell';

const Container = styled.div(({ theme }) => {
  const { shadow, color } = theme;

  return `
    border-radius: 16px;
    box-shadow: ${shadow.regular};
    background: ${color.grayscale[1000]};
    padding: 32px;
    display: grid;
    grid-gap: 16px;
  `;
});

const MyZone: FC = () => {
  const [analyticsInfo, setAnalyticsInfo] = useState<MyZoneResponse>();
  // TODO: Set up typing for redux store

  useEffect(() => {
    MyZoneService.getTherapistsAnalyticsById()
      .then((results) => {
        setAnalyticsInfo(results);
      })
      .catch((error) => {
        throw new Error(`Error retreiving statistics ${error}`);
      });
  }, []);

  const mostPlayedGame = analyticsInfo?.mostPlayedGame.gameName ? analyticsInfo.mostPlayedGame.gameName : false;

  const mostPlayedSkill = analyticsInfo?.mostPlayedSkill.FunctionalSkillName
    ? analyticsInfo.mostPlayedSkill.FunctionalSkillName
    : false;

  return (
    <section>
      <BlockHeader>My Zone</BlockHeader>

      <Container>
        <Cell
          icon={analyticsInfo?.mostPlayedGame.imagePath ? analyticsInfo?.mostPlayedGame.imagePath : false}
          type="game"
          smallText="MOST PLAYED GAME"
          largeText={mostPlayedGame || '-'}
        />

        <Cell
          icon={
            analyticsInfo?.mostPlayedSkill.FunctionalSkillIconPath
              ? analyticsInfo.mostPlayedSkill.FunctionalSkillIconPath
              : false
          }
          type="functional_skill"
          smallText="MOST PLAYED SKILL"
          largeText={mostPlayedSkill || '-'}
          button={{
            text: 'How about trying something new today?',
            callback: () => {
              // TODO: Handle callback here
              return true;
            },
          }}
        />
        {analyticsInfo && (
          <>
            <SmallCell statistic={analyticsInfo.numberOfActivities} description="Number of Activities" />
            <SmallCell statistic={analyticsInfo.numberOfActivePatients} description="Number of Active Patients" />
          </>
        )}
      </Container>
    </section>
  );
};

export default MyZone;
